export default __webpack_public_path__ + "static/media/hht2_ep02_book_wp_02.45b0525e.jpg";